import getConfig from 'next/config';
import { useRouter } from 'next/router';

import axios from 'axios';
import useSWR from 'swr';

import { useFeatureFlagContext } from 'utils/unleashFeatureFlags/FeatureFlagProvider';
import { FEATURE_FLAGS } from 'utils/unleashFeatureFlags/flags';

export const useCaptionsURL = (organizationId?: string) => {
  const { publicRuntimeConfig } = getConfig();
  const { features } = useFeatureFlagContext();
  const { query } = useRouter();
  const transcriptionsFlag = features[FEATURE_FLAGS.ENTERPRISE_TRANSCRIPTIONS];
  // USE THIS URL TO TEST -> 'https://storage.googleapis.com/morressier-text-to-speech/sample_videos/bingham_degrasse.vtt';
  const vttUrl =
    transcriptionsFlag && organizationId
      ? `${publicRuntimeConfig.repo_api}/organizations/${organizationId}/events/${query.eventId}/documents/${query.article_id}/transcription?vtt=true`
      : '';
  const { data, isValidating } = useSWR<string>(vttUrl, url =>
    axios.get(url).then(res => res.data),
  );
  const blobURL = data && URL.createObjectURL(new Blob([data], { type: 'text/vtt' }));
  return { captionsUrl: blobURL, loading: isValidating };
};
